import {ReactElement} from 'react'
import {
    Dialog,
    DialogDisclosure,
    DialogDismiss,
    DialogHeader,
    DialogHeading,
    DialogBody
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {DialogProvider, DialogStore} from '@ariakit/react'
import {AbsenceForm} from '../absence-form/AbsenceForm'
import {AbsenceFormProvider} from '../absence-form/AbsenceFormProvider'
import {AbsenceDialogFooter} from './AbsenceDialogFooter'
import {CreateAbsenceFormValidationSchema} from '../../formSchemas'

interface CreateAbsenceDialogProps {
    defaultValues?: Partial<CreateAbsenceFormValidationSchema>
    trigger?: ReactElement
    dialogStore?: DialogStore
}

export const CreateAbsenceDialog = ({defaultValues, trigger, dialogStore}: CreateAbsenceDialogProps) => {
    return (
        <DialogProvider store={dialogStore}>
            <DialogDisclosure render={trigger} />
            <Dialog width="680px" overflowY="unset">
                <CreateAbsenceDialogContent defaultValues={defaultValues} />
            </Dialog>
        </DialogProvider>
    )
}

const CreateAbsenceDialogContent = ({defaultValues}: {defaultValues?: Partial<CreateAbsenceFormValidationSchema>}) => {
    const {t} = useTranslation()

    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('accesses:add_absence')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>
            <AbsenceFormProvider defaultValues={defaultValues}>
                <DialogBody>
                    <AbsenceForm />
                </DialogBody>
                <AbsenceDialogFooter />
            </AbsenceFormProvider>
        </>
    )
}
